import React from 'react';
import PropTypes from 'prop-types';
import './dropdown-single-select-selector.scss';
import clsx from 'clsx';
import { ChevronDown, ChevronUp } from 'react-feather';
import Icon, { IconColors, IconSizes } from '../icon';
import Image from '../image';

const DropdownSingleSelectSelector = React.forwardRef(({
  item, placeholder, renderPlaceholderIcon, dropdownOpen, disabled, label, showLabelInline,
  selctorTestId,
}, ref) => {
  let valueView;
  let imageIconView;
  let helperView = null;

  const getImageOrIcon = (image, renderIcon) => {
    if (image) {
      return <Image className="dd-single-select-image" src={image} />;
    }
    if (renderIcon || renderPlaceholderIcon) {
      return (
        <span
          className="dd-single-select-icon"
        >
          {renderIcon({ size: IconSizes.MEDIUM, color: IconColors.GREY })}
        </span>
      );
    }
    return null;
  };

  const getValueView = (value) => {
    if (value) {
      return (
        <div className="dd-single-select-value">
          {showLabelInline && <span className="dd-single-select-inline-label">{label}</span>}
          {value}
        </div>
      );
    }
    if (placeholder) {
      return (
        <div className="dd-single-select-placeholder">
          {(label && showLabelInline) ? `${label}: ${placeholder}` : placeholder}
        </div>
      );
    }
    return (
      <div className="dd-single-select-placeholder">
        {(label && showLabelInline) ? `${label}` : null}
      </div>
    );
  };

  const getHelperView = (helper) => {
    if (helper) {
      return <div className="dd-single-select-helper">{helper}</div>;
    }
    return null;
  };

  const getArrow = () => (
    <Icon
      className="dd-single-select-chevron"
      icon={dropdownOpen ? ChevronUp : ChevronDown}
      size={IconSizes.MEDIUM}
      color={IconColors.GREY}
    />
  );

  if (item) {
    const {
      label: itemLabel, image, renderIcon, helper,
    } = item;
    imageIconView = getImageOrIcon(image, renderIcon);
    valueView = getValueView(itemLabel);
    helperView = getHelperView(helper);
  } else {
    imageIconView = getImageOrIcon();
    valueView = getValueView();
  }

  return (
    <button
      ref={ref}
      type="button"
      disabled={disabled}
      className={clsx('dd-single-select-selector', {
        'ddss-active': dropdownOpen,
        'ddss-disabled': disabled,
      })}
      data-testid={selctorTestId}
    >
      {imageIconView}
      {valueView}
      {helperView}
      {!disabled && getArrow()}
    </button>
  );
});

DropdownSingleSelectSelector.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    label: PropTypes.string,
    renderIcon: PropTypes.func,
    image: PropTypes.string,
    helper: PropTypes.string,
  }),
  placeholder: PropTypes.string,
  renderPlaceholderIcon: PropTypes.func,
  dropdownOpen: PropTypes.bool,
  disabled: PropTypes.bool,
  showLabelInline: PropTypes.bool,
  label: PropTypes.string,
  selctorTestId: PropTypes.string,
};

DropdownSingleSelectSelector.defaultProps = {
  item: {},
  placeholder: '',
  renderPlaceholderIcon: null,
  dropdownOpen: false,
  disabled: false,
  showLabelInline: false,
  label: '',
  selctorTestId: null,
};

export default DropdownSingleSelectSelector;
